import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import { ROUTE_PATHS } from 'router/routes'

import { Referral } from 'pages/Auth/Referral'

import ProtectedRoute from 'components/helpers/ProtectedRoute/ProtectedRoute'

const SignUp = React.lazy(() => import('pages/Auth/modals/SignUpModal'))

export class AuthModule {
  getRoutes() {
    return (
      <Route key={ROUTE_PATHS.AUTH} path={ROUTE_PATHS.AUTH}>
        <Switch>
          <ProtectedRoute
            key={ROUTE_PATHS.AUTH_SIGN_UP_WITH_PROMOCODE}
            path={ROUTE_PATHS.AUTH_SIGN_UP_WITH_PROMOCODE}
            forAuth={false}
            component={SignUp}
          />
          <ProtectedRoute
            key={ROUTE_PATHS.AUTH_SIGN_UP}
            path={ROUTE_PATHS.AUTH_SIGN_UP}
            forAuth={false}
            component={SignUp}
          />
          <QueryParamProvider ReactRouterRoute={Route}>
            <Route key={ROUTE_PATHS.REFERRAL} path={ROUTE_PATHS.REFERRAL} component={Referral} />
          </QueryParamProvider>
        </Switch>
      </Route>
    )
  }
}
